var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramSquared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "url(#paint0_linear_10952_55472)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0488281 7.65599C0.0488281 4.05599 0.0488281 2.24799 1.16083 1.12799C2.28883 0.0159913 4.08883 0.0159912 7.69683 0.0159912H8.33683C11.9368 0.0159912 13.7448 0.0159913 14.8648 1.12799C15.9768 2.23999 15.9768 4.05599 15.9768 7.65599V8.29599C15.9768 11.896 15.9768 13.704 14.8648 14.824C13.7528 15.936 11.9368 15.936 8.33683 15.936H7.69683C4.09683 15.936 2.28883 15.936 1.16883 14.824C0.0488282 13.704 0.0488281 11.904 0.0488281 8.29599V7.65599Z",
    fill: "url(#paint1_linear_10952_55472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70824 7.91553C6.06955 6.89945 7.64413 6.22958 8.43198 5.90593C10.6814 4.98186 11.1488 4.82134 11.4535 4.81604C11.5205 4.81487 11.6703 4.83127 11.7674 4.90905C11.8493 4.97472 11.8719 5.06343 11.8827 5.1257C11.8935 5.18796 11.9069 5.3298 11.8962 5.44063C11.7743 6.70562 11.2469 9.77541 10.9785 11.1922C10.865 11.7917 10.6414 11.9927 10.425 12.0124C9.95457 12.0552 9.59739 11.7054 9.1418 11.4104C8.42889 10.9489 8.02615 10.6616 7.33415 10.2112C6.53442 9.69068 7.05285 9.4046 7.50861 8.93708C7.62789 8.81472 9.7004 6.95288 9.74051 6.78398C9.74553 6.76286 9.75019 6.68412 9.70283 6.64255C9.65546 6.60097 9.58556 6.61519 9.53512 6.62649C9.46362 6.64252 8.32474 7.38598 6.11849 8.85688C5.79522 9.07612 5.50242 9.18294 5.24008 9.17734C4.95087 9.17117 4.39454 9.01583 3.98097 8.88306C3.4737 8.7202 3.07054 8.6341 3.10565 8.35752C3.12393 8.21346 3.3248 8.06613 3.70824 7.91553Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10952_55472",
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 1588.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10952_55472",
    x1: 796.449,
    y1: 0.0159912,
    x2: 796.449,
    y2: 1580.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramSquared);
export default __webpack_public_path__ + "static/media/telegram-squared.637490cdaf63f9af211384ff32d2c9be.svg";
export { ForwardRef as ReactComponent };